import React from 'react';
import 'bootstrap/dist/css/bootstrap.css';
import certificados from './images/certificados.svg';
import './Footer.css';
import { useTranslation } from "react-i18next";

function Footer(props){
	const [tFooter] = useTranslation("footer")

	return(
		<React.StrictMode>
			<footer className="footer ">
				<div className="container">
					<div className="row px-md-0 px-4">
						<div className="col-md-12 copy-footer">
							<div className="row">
								<div className="col-md-6">
									<p className="footer__contact__phone_p d-none d-md-block">©Copyright {new Date().getFullYear()} { tFooter("column4.text-1") }</p>
									<p className="footer__contact__phone_p d-block d-md-none text-center fs-12">©Copyright {new Date().getFullYear()} { tFooter("column4.text-1") }</p>
								</div>
								<div className="col-md-6">
									<p className="footer__contact__phone_p text-end d-none d-md-block">
										{ tFooter("column4.text-2") } <img className="servicios-icon2" src={ certificados } alt='' /> 
									</p>
									<p className="footer__contact__phone_p d-block d-md-none text-center fs-12">
										{ tFooter("column4.text-2") } <img className="servicios-icon2" src={ certificados } alt='' /> 
									</p>
								</div>
							</div>
						</div>
					</div>
				</div>
			</footer>
		</React.StrictMode>
	);
}

export default Footer;